import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { TemplateTwentyOnePDFSection, TemplateTwentyOneSection } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateTwentyOneSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && <ResumePDFText themeColor="black">{summary}</ResumePDFText>}
      </View>
    </TemplateTwentyOneSection>
  );
};
